import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const TrashIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1667 6C9.86989 6 9.58844 6.13182 9.39845 6.35982L5.23178 11.3598C4.92274 11.7307 4.92274 12.2693 5.23178 12.6402L9.39845 17.6402C9.58844 17.8682 9.86989 18 10.1667 18H18C18.5523 18 19 17.5523 19 17V7C19 6.44772 18.5523 6 18 6H10.1667ZM11.3447 10.3536L12.9911 12L11.3447 13.6464L12.0518 14.3536L13.6982 12.7071L15.3447 14.3536L16.0518 13.6464L14.4053 12L16.0518 10.3536L15.3447 9.64645L13.6982 11.2929L12.0518 9.64645L11.3447 10.3536Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { TrashIcon };
